import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';
import { Checkbox } from '../../../components/ui/Checkbox';

const ExportPanel = ({ actions, onExport }) => {
  const [exportFormat, setExportFormat] = useState('pdf');
  const [includeMetrics, setIncludeMetrics] = useState(true);
  const [includeRisks, setIncludeRisks] = useState(true);
  const [includeTimeline, setIncludeTimeline] = useState(true);
  const [selectedPeriods, setSelectedPeriods] = useState([30, 60, 90]);

  const formatOptions = [
    { value: 'pdf', label: 'PDF Document' },
    { value: 'excel', label: 'Excel Spreadsheet' },
    { value: 'word', label: 'Word Document' }
  ];

  const handlePeriodToggle = (period) => {
    setSelectedPeriods(prev => 
      prev?.includes(period) 
        ? prev?.filter(p => p !== period)
        : [...prev, period]
    );
  };

  const handleExport = () => {
    const exportData = {
      format: exportFormat,
      actions: actions?.filter(a => selectedPeriods?.includes(a?.period)),
      options: {
        includeMetrics,
        includeRisks,
        includeTimeline
      },
      timestamp: new Date()?.toISOString()
    };
    
    onExport(exportData);
  };

  return (
    <div className="bg-card rounded-xl border border-border p-6">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
          <Icon name="Download" size={20} className="text-primary" />
        </div>
        <div>
          <h3 className="text-lg font-semibold text-foreground">Export Rencana Aksi</h3>
          <p className="text-sm text-muted-foreground">Unduh dokumen implementasi lengkap</p>
        </div>
      </div>
      <div className="space-y-6">
        <Select
          label="Format Export"
          options={formatOptions}
          value={exportFormat}
          onChange={setExportFormat}
        />

        <div className="space-y-3">
          <label className="text-sm font-medium text-foreground">Periode yang Disertakan</label>
          <div className="space-y-2">
            <Checkbox
              label="30 Hari"
              checked={selectedPeriods?.includes(30)}
              onChange={() => handlePeriodToggle(30)}
            />
            <Checkbox
              label="60 Hari"
              checked={selectedPeriods?.includes(60)}
              onChange={() => handlePeriodToggle(60)}
            />
            <Checkbox
              label="90 Hari"
              checked={selectedPeriods?.includes(90)}
              onChange={() => handlePeriodToggle(90)}
            />
          </div>
        </div>

        <div className="space-y-3">
          <label className="text-sm font-medium text-foreground">Konten Tambahan</label>
          <div className="space-y-2">
            <Checkbox
              label="Metrik & Statistik"
              description="Sertakan ringkasan metrik implementasi"
              checked={includeMetrics}
              onChange={(e) => setIncludeMetrics(e?.target?.checked)}
            />
            <Checkbox
              label="Analisis Risiko"
              description="Sertakan indikator risiko implementasi"
              checked={includeRisks}
              onChange={(e) => setIncludeRisks(e?.target?.checked)}
            />
            <Checkbox
              label="Timeline Visual"
              description="Sertakan diagram timeline implementasi"
              checked={includeTimeline}
              onChange={(e) => setIncludeTimeline(e?.target?.checked)}
            />
          </div>
        </div>

        <div className="pt-4 border-t border-border">
          <Button
            variant="default"
            fullWidth
            iconName="Download"
            iconPosition="left"
            onClick={handleExport}
            disabled={selectedPeriods?.length === 0}
          >
            Export Rencana Aksi
          </Button>
          <p className="text-xs text-muted-foreground text-center mt-3">
            {actions?.filter(a => selectedPeriods?.includes(a?.period))?.length} aksi akan diekspor
          </p>
        </div>
      </div>
    </div>
  );
};

export default ExportPanel;